import { loadBrandConfig } from './loadBrandConfig'

/**
 * 阅读器路由名称（构建时确定）
 * - novelarc: chapter-scroll（无限滚动）
 * - 其他品牌: chapter（翻页）
 */
export const READER_ROUTE_NAME = loadBrandConfig({
  rocnovel: 'chapter',
  oceread: 'chapter',
  ficmoon: 'chapter',
  novelarc: 'chapter-scroll',
  storyella: 'chapter-scroll',
  silktale: 'chapter-scroll',
  pearla: 'chapter-scroll',
}) as 'chapter' | 'chapter-scroll'
